export const SEO_DEFAULTS = {
  siteName: "KeptScene",
  siteDescription: "Create beautiful photo booth experiences with customizable frames, filters, and effects. Capture and share your moments with KeptScene.",
  siteUrl: import.meta.env.VITE_SITE_URL || (typeof window !== 'undefined' ? window.location.origin : ''),
  defaultOgImage: import.meta.env.VITE_DEFAULT_OG_IMAGE || "/kept-scene-logo.png",
  twitterHandle: "@keptscene",
} as const;

export interface SEOConfig {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: "website" | "article" | "product";
  noindex?: boolean;
  canonical?: string;
  structuredData?: object | object[];
}

